import { render, staticRenderFns } from "./unsubscribed-user-list.html?vue&type=template&id=af7f8682&scoped=true&external"
import script from "./unsubscribed-user-list.js?vue&type=script&lang=js&external"
export * from "./unsubscribed-user-list.js?vue&type=script&lang=js&external"
import style0 from "./unsubscribed-user-list.scss?vue&type=style&index=0&id=af7f8682&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7f8682",
  null
  
)

export default component.exports